import { useState } from 'react';
import usePagination from './usePagination';
import useDidMountEffect from './useDidMountEffect';

export default function useBrowsePerPlace({
  place,
  initItems = [],
  initTotalResults = 0,
  scrollToRef,
  limit,
}) {
  const [items, setItems] = useState(initItems);
  const [totalResults, setTotalResults] = useState(initTotalResults);
  const [loading, setLoading] = useState(false);

  const fetchItems = async ({ page }) => {
    setLoading(true);
    await fetch(`/api/browse/place?place=${place}&page=${page}`)
      .then(res => res.json())
      .then(data => {
        setItems(data.results);
        setTotalResults(data.totalResults);
      })
      .finally(() => setLoading(false));
  };

  const {
    currentPage,
    totalPages,
    hasNextPage,
    hasPrevPage,
    handleNextPage,
    handlePrevPage,
    handleGoToPage,
    resetPagination,
  } = usePagination({
    total: totalResults,
    limit,
    fetchMore: fetchItems,
    scrollToRef,
  });

  useDidMountEffect(() => {
    fetchItems({ page: currentPage });
  }, [place]);

  return {
    items,
    totalResults,
    loading,
    currentPage,
    totalPages,
    hasNextPage,
    hasPrevPage,
    handleNextPage,
    handlePrevPage,
    handleGoToPage,
    resetPagination,
  };
}
